<template>
  <!-- <el-container class="index-con">
    <el-header class="index-header">
      <navcon></navcon>
    </el-header>
    <el-container class="index-con">
      <el-aside :class="showclass">
        <leftnav></leftnav>
      </el-aside>
      <el-container class="main-con">
        <el-main clss="index-main">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </el-container> -->

  <el-container class="index-con">
    <el-aside :class="showclass">
		<div class="logobox">
		  <img class="logoimg" src="../assets/img/copy.png" alt="">
		 <!-- <div class="logotitle">营销导购后台</div> -->
		</div>
      <leftnav></leftnav>
    </el-aside>
    <el-container class="main-con">
      <el-header class="index-header">
        <navcon></navcon>
      </el-header>
      <el-main class="index-main">
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
// 导入组件
import navcon from '../components/navcon.vue'
import leftnav from '../components/leftnav.vue'
export default {
  name: 'index',
  data() {
    return {
      showclass: 'asideshow',
      showtype: false
    }
  },
  // 注册组件
  components: {
    navcon,
    leftnav
  },
  methods: {},
  created() {
    // 监听
    this.$root.Bus.$on('toggle', value => {
      if (value) {
        this.showclass = 'asideshow'
      } else {
        setTimeout(() => {
          this.showclass = 'aside'
        }, 300)
      }
    })
  },
  beforeUpdate() {},
  // 挂载前状态(里面是操作)
  beforeMount() {
    // 弹出登录成功
    // this.$message({
    //   message: '登录成功',
    //   type: 'success'
    // })
  }
}
</script>
<style >
.index-con {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

.aside {
  width: 64px !important;
  height: 100%;
  background-color: #fff;
  margin: 0px;
}
.asideshow {
  width: 240px !important;
  height: 100%;
  background-color: #fff;
   border-bottom: 1px solid #e6e6e6;
  margin: 0px;
  overflow: hidden;
}
.index-header,
.index-main {
  padding: 0px;
  /* border-left: 2px solid #333; */
 
}
/deep/ .el-aside{
	overflow: hidden;
}
.index-main{
	margin: 20px;
	background-color: #F7F8FA;
	position: relative;
}
.logobox {
  height: 60px;
  color: #9d9d9d;
  font-size: 20px;
  border-bottom: 1px solid #e6e6e6;
}
.logoimg {
  height: 40px;
  margin-left: 20px;
  margin-top: 10px;
}
.el-menu-item-group .is-active{
	background-color: #e6f7ff;
}
.logotitle{
	font-size: 20px;
	height: 60px;
	line-height: 60px;
	color: #101010;
	float: right;
	font-weight: bold;
	margin-right: 55px;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue